import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { CoreCustomFormsModule } from '@core/custom-forms/components/custom-forms-components.module';

import { SettingsFormsFormMainComponent } from './main/main.component';
import { SettingsDynamicFieldHostComponent } from './settings-dynamic-field-host.component';
// import { SettingsDynamicFieldHost2Component } from './settings-dynamic-field-host2.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        CoreModule,
        HelpersModule,
        // CoreCustomFormsFieldsModule,
        // CoreCustomFormsSettingsFieldsModule
        CoreCustomFormsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsFormsFormMainComponent,
        SettingsDynamicFieldHostComponent,
        // SettingsDynamicFieldHost2Component
    ],
    exports: [
        SettingsFormsFormMainComponent,
        // SettingsDynamicFieldHost2Component
    ],

})
export class SettingsFormsFormModule { }
